

export default {
  name: "SliderSection",
  props: ['zone'],
}
